import axios from 'axios'

class ApplicationIconsService {
  constructor (apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Lucia Alvarado
  * @description Get icons MiFirma
  * @date 28-10-2022
  * @param {String} token
  * @returns {Object}
  * @memberof ApplicationIconsService
  */
  async getApplicationIcons (token) {
    let response = await axios.get(`${this.apiUrl}/application-icons`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
  

}

export { ApplicationIconsService as default }
